<div class="container">
  <mat-dialog-content class="dialog-container">
    <div class="dialog-header">
      <div mat-dialog-title class="title">
        <span i18n="@@ViewAllGoodsAndServicesDialogTitle"
          >Goods and Services for</span
        >
        "{{ trademarkName }}"
      </div>
      <button
        mat-dialog-close
        class="material-icons close-icon"
        mat-icon-button
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="goodsAndServices-description">
      {{ goodsAndServices }}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      class="cdx-but-md"
      color="primary"
      mat-stroked-button
      mat-dialog-close
      i18n="@@ViewAllGoodsAndServicesDialogBackButton"
    >
      Back
    </button>
  </mat-dialog-actions>
</div>
